import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAdobeaftereffectsComponent } from './simple-icons-adobeaftereffects.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAdobeaftereffectsComponent ],
    exports:      [ SimpleIconsAdobeaftereffectsComponent ],
    bootstrap:    []
})
export class SimpleIconsAdobeaftereffectsModule {}
